// src/serviceWorkerRegistration.js
// This optional code is used to register a service worker.
// register() is not called by default.

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

export function register(config) {
  // Disable service worker in development/localhost
  if (process.env.NODE_ENV === 'development' || isLocalhost) {
    console.log('Service worker disabled in development');
    return;
  }

  // Original service worker registration code (optional - for production)
  if ('serviceWorker' in navigator) {
    // Your existing code...
  }
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then(registration => {
        registration.unregister();
      })
      .catch(error => {
        console.error(error.message);
      });
  }
}